import { css } from "twin.macro";
import AppStoreImg from "./AppStore.png";

export default function AppStoreLink({ height = 50, className, appUrl }) {
    if (!appUrl) return null;

    return (
        <a href={appUrl} target="_blank" rel="noreferrer" className={className}>
            <img
                src={AppStoreImg}
                alt="Stáhnout z AppStore"
                css={css`
                    height: ${height}px;
                `}
            />
        </a>
    );
}
